<template>
  <el-row>
    <el-col :span="24">
      <div class="header" :class="{ langCN: $store.state.lang === 'zh' }">
        <div class="container">
          <el-col :span="24" :xs="24" :xl="24" class="header-top-left"
            style="display: flex;align-items: center;height: 65px;">
            <el-col :span="11" :offset="1" class="header-col">
              <img :src="$config.FILE_URL + oemCompany.logo" class="header-logo" />
              <strong class="hidden-xs-only header-title">{{
                lang == 'zh' ? oemCompany.systemName && oemCompany.systemName['zh-cn'] :
                oemCompany.systemName && oemCompany.systemName[lang]
              }}</strong>
            </el-col>
            <el-col :span="12" :xs="12" style=" display: flex; justify-content: flex-end;" class="header-col">
              <!-- v-show="true" -->
              <div class="grid-content bg-purple-white">
                <!--首页-->
                <div :class="['so-normal', isCurrentRoute('index') ? 'so-active' : '']">
                  <span class="el-dropdown-link"><router-link to="/index">{{ $t('HOME') }}</router-link></span>
                </div>
                <!--贸易情报-->
                <el-dropdown class="so-normal">
                  <span class="el-dropdown-link"><a
                      :href="$store.state.oemCompany.dataDomain + '/#/shipments/searching'">{{ $t('HEADER_SHIPMENTS') }}</a></span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item><a
                        :href="$store.state.oemCompany.dataDomain + '/#/shipments/searching'">{{ $t('HEADER_ADVANCED_SEARCH') }}</a>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="hasPartnerPermission()"><a
                        :href="$store.state.oemCompany.dataDomain + '/#/shipments/partners-report'">{{ $t('HEADER_PARTNERS_REPORT') }}</a>
                    </el-dropdown-item>
                    <el-dropdown-item><a
                        :href="$store.state.oemCompany.dataDomain + '/#/shipments/collect'">{{ $t('SHIPMENTS_MY_COLLECTION') }}</a></el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>

                <!--<li v-show="this.$i18n.locale == 'zh'" class="so-normal">-->
                <!--<a :href="$store.state.oemCompany.dataDomain+'/#/shipments/buyer'">{{$t('HEADER_BUYER_SEARCH_TITLE')}}</a>-->
                <!--</li>-->
                <!--无界搜索-->
                <el-dropdown :class="['so-normal', isCurrentRoute('so') || looseEqualRoute(['so', 'email']) ? 'so-active' : '']"
                  v-if="hasTradeSOPermission()">
                  <span class="el-dropdown-link"><router-link to="/so/index">{{ $t('HEADER_SO') }}</router-link></span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <router-link to="/so/index">{{ $t('HEADER_SO_SEARCH') }}</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/so/history">{{ $t('HEADER_SO_SEARCH_RECORDS') }}</router-link>
                    </el-dropdown-item>
                    <!--<el-dropdown-item><router-link to="/email">{{$t('HEADER_EMAIL_CENTER')}}</router-link></el-dropdown-item>-->
                  </el-dropdown-menu>
                </el-dropdown>

              </div>
              <el-col style="float: right;width: auto;">
                <div class="header-language">
                  <div class="header-role">
                    <el-dropdown :hide-on-click="false">
                      <span class="el-dropdown-link">
                        {{ session.firstName }} {{ session.lastName }}
                          <span v-if="session.userAvatar">
                            <img :src= session.userAvatar class="userAvatar" />
                          </span>
                          <span v-if="oemCompany.other && !JSON.parse(oemCompany.other).shieldUserInfo">
                            <i class="el-icon-medal icon-medal bronze" v-if="hasPermission($config.PERMISSION.BRONZE)"></i>
                            <i class="el-icon-medal icon-medal silver light"
                              v-if="hasPermission($config.PERMISSION.SILVER)"></i>
                            <i class="el-icon-medal icon-medal gold" v-if="hasPermission($config.PERMISSION.GOLD)"></i>
                            <i class="fa fa-shield navbar-fa-shield-pro" v-if="hasPermission($config.PERMISSION.PRO)"></i>
                            <i class="fa fa-shield badge-global" v-if="hasPermission($config.PERMISSION.GLOBAL)"></i>
                            <i class="fa fa-shield badge-global-plus"
                              v-if="hasPermission($config.PERMISSION.GLOBAL_PLUS)"></i>
                            <i class="fa fa-shield badge-global-luxury"
                              v-if="hasPermission($config.PERMISSION.GLOBAL_LUXURY)"></i>
                            <i class="fa fa-shield badge-global-deluxe"
                              v-if="hasPermission($config.PERMISSION.GLOBAL_DELUXE)"></i>
                            <i class="el-icon-arrow-down el-icon--right"></i>
                          </span>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>
                          <a v-if="oemCompany.lang && oemCompany.lang.length > 1" type="text" @click="changeLang('en')"
                            title="ENGLISH">EN</a>
                        </el-dropdown-item>
                        <el-dropdown-item>
                          <a v-if="oemCompany.lang && oemCompany.lang.length > 1" type="text" @click="changeLang('zh')"
                            title="中文">中文</a>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="(oemCompany.other && !JSON.parse(oemCompany.other).shieldUserInfo && !JSON.parse(oemCompany.other).login_url) || (session.companyRole === 'manage')">
                          <router-link to="/user/setting" target="_blank"><i class="fa fa-cog"
                              aria-hidden="true"></i>{{ $t('USER_ACCOUNT_SETTING') }}</router-link>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                  <div class="header-language-font" v-if="(oemCompany.other && !JSON.parse(oemCompany.other).login_url) || (session.companyRole === 'manage')">
                    <el-button type="text" @click="signout()">{{ $t('HEADER_NAVBAR_SIGN_OUT') }}</el-button>
                  </div>
                </div>
              </el-col>
            </el-col>
          </el-col>
          <div class="clear"></div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { MessageBox } from 'element-ui';

export default {
  name: 'Header',
  data() {
    return {
      toggleMobileNav: true,
      isLoaded: false,
      DOMAIN: document.domain.substring(document.domain.indexOf('.')),
    };
  },
  computed: {
    ...mapState(['lang', 'session', 'oemCompany']),
    ...mapGetters(['isAdmin', 'isInfo', 'hasPermission', 'hasPartnerPermission', 'hasTradeSOPermission', 'isMasterAccount'])
  },
  beforeMount: async function () {
    if (window.location.pathname == '/login') return
    if (_.isEmpty(this.$store.getters['getSession'])) {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if(token)  this.$cookies.set('oemToken', token, -1, '/', this.DOMAIN);
      await this.$apiService.post('/user/identity')
        .then(result => {
          if (result && result.code === 1) {
            let user = _.get(result, 'data');
            this.$store.commit('setSession', user);
            //国际化
            user.lang = user.lang == 'zh-cn' ? 'zh' : 'en'
            this.$i18n.locale = user.lang;
            this.$store.commit('setLang', user.lang);
            const router = this.$router;
            const currentPath = router.currentRoute.path;
            // 构建新的路由路径，去掉token字段  
            if(token){
              const newPath = currentPath.replace(/(\?|&)?token=[^&]+/, '');
              router.push(newPath);
            }
          } else {
            //401,402校验
            if (result.code === 401 || result.code === 402) {
              let message = this.$t(result.code);
              MessageBox.confirm(message, this.$t('NOTICE'), {
                type: 'warning',
                showCancelButton: false,
                showClose: false,
                closeOnHashChange: false,
                closeOnPressEscape: false,
                closeOnClickModal: false,
                confirmButtonClass: 'origin',
                confirmButtonText: this.$t('CONFIRM')
              }).then( () => {
                if (this.$store.state.oemCompany.other && JSON.parse(this.$store.state.oemCompany.other).login_url) {
                  window.location.href = JSON.parse(this.$store.state.oemCompany.other).login_url; // 江苏 苏豪纺织
                }else {
                  this.loginFun()
                }

              })
            }
          }
        })
    }
  },
  methods: {
    loginFun(){
         this.$apiService.post(`/public/sso/login?back=${window.location.href}`).then(res => {
        if (res.code === 403) {
          if (this.$store.state.oemCompany.other && JSON.parse(this.$store.state.oemCompany.other).login_url) {
            window.location.href = JSON.parse(this.$store.state.oemCompany.other).login_url; // 江苏 苏豪纺织
          } else {
           window.location.href = '/login';
          }
        } else {
          window.location.href = res;
        }
      }).catch(err => {
        console.log(err, 'err')
      })
    },
    isCurrentRoute(route) {
      return this.$route.name == route;
    },
    looseEqualRoute(route) {
      if (!this.$route.name) return;
      if (Array.isArray(route)) {
        return route.find(item => this.$route.name.includes(item));
      }
      return this.$route.name.includes(route);
    },
    signout() {
      // this.$apiService.post('/user/signout').then(result => {
      //   this.$router.push({name: 'login'});
      // });
      this.$apiService.post('/user/sso/logout').then(result => {
        // this.$cookies.remove("user");
        this.$cookies.remove("oemToken", '/', this.DOMAIN);
        this.$cookies.remove("ts-token");
        if(this.$store.state.oemCompany.other && JSON.parse(this.$store.state.oemCompany.other).shieldUserInfo){
          this.loginFun()
        }else {
        this.$router.push({ name: 'login' });
        }
        
      });
    },
    changeLang: function (currentLang) {
      this.$i18n.locale = currentLang;
      this.$store.commit('setLang', currentLang);
      //title
      document.title = this.$store.state.oemCompany.systemName[currentLang] || '';
      //持久化
      this.$store.dispatch("sendLang", { lang: currentLang == 'zh' ? 'zh-cn' : 'en' });
      // this.$store.dispatch("sendLang", {lang: currentLang });
    }
  },
  mounted() {
    function isMobile() {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    }

    if (isMobile()) {
      this.toggleMobileNav = false;
    } else {
      this.toggleMobileNav = true;
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div.header-col {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 70px;
}

strong {
  font-size: 20px;
}

.header-logo {
  height: 50px;
}

.header-title {
  margin-left: 20px;
}

.langCN {
  font-family: "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", "WenQuanYi Micro Hei", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.langCN button {
  font-family: "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", "WenQuanYi Micro Hei", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
}

div.so-active span a {
  color: #faad14;
}

@media (max-width: 768px) {
  /* .grid-content {
      display: none;
    } */

  div.header {
    min-height: 100px;
  }

  .header-language {
    position: absolute;
    top: 59px;
    right: 0px;
    justify-content: flex-end;
  }

  div.header-role {
    padding: 0px;
  }

  .header-role div.el-dropdown {
    margin-right: 5px;
  }
}

div.container {
  width: 100%;
  padding: 0px;
  background: #fff;
  color: rgb(51, 51, 51);
}

div.header {
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, .08);
  background: #fff;
}

.header-role {
  padding: 12px;
  float: left;
}

@media (max-width: 1280px) {
  .container {
    width: 84%;
  }

  div.bg-purple-white .so-normal,
  div.bg-purple-white .el-dropdown {
    margin-right: 8px;
    height: 30px;
    line-height: 30px;
  }
}

div.header .el-button {
  border-color: #337ab7;
  background-image: none;
}

.header-role span {
  float: right;
  margin-right: 9px;
  margin-left: 10px;
}

.header-language-font {
  float: left;
  width: auto;
  display: inline;
}

.font-color-yellow {
  color: yellow;
}

.mobile_button {
  float: right;
  margin-top: 10px;
}

.mobile_button i.fa {
  font-size: 23px;
}

.icon-medal:after,
.navbar-fa-shield-pro:after,
.icon-medal.bronze:after,
.icon-medal.silver.light:after,
.badge-global:after,
.badge-global-plus:after,
.badge-global-luxury:after,
.badge-global-deluxe:after {
  font-family: Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif;
  text-transform: uppercase;
  font-weight: 700;
  padding-left: 3px;
}

.header-role i.navbar-fa-shield-pro {
  color: #357ebd;
}

.navbar-fa-shield-pro:after {
  content: "pro";
}

.icon-medal.bronze {
  color: #b1875b;
}

.icon-medal.bronze:after {
  content: "铜牌";
}

.icon-medal.silver.light {
  color: #696969;
}

.icon-medal.silver.light:after {
  content: "银牌";
}

.icon-medal.gold {
  color: #fac33c;
}

.icon-medal.gold:after {
  content: '金牌';
}

.badge-global {
  color: #fac33c;
}

.badge-global:after {
  content: 'global';
}

.badge-global-plus {
  color: #fac33c;
}

.badge-global-plus:after {
  content: 'plus';
}

.badge-global-luxury {
  color: #fac33c;
}

.badge-global-luxury:after {
  content: 'luxury';
}

.badge-global-deluxe {
  color: #fac33c;
}

.badge-global-deluxe:after {
  content: 'deluxe';
}

.el-menu--horizontal i.fa {
  color: #fff;
  margin-right: 5px;
}

.header-language-font span:hover {
  color: #fff;
}

.header .header-language .header-language-font button.active,
.header .header-language .header-language-font button.active span,
.header .header-language .header-language-font button.el-button:hover {
  color: rgb(51, 51, 51);
}

div.header .header-language .el-button {
  margin-top: 0;
  font-size: 13px;
}

.el-menu--horizontal>.el-menu-item {
  color: #fff;
}

.el-menu--horizontal>.el-menu i {
  color: #333;
}

.so-active {
  box-shadow: 0 0 0;
  font-weight: bold;
  font-size: 15px;
}

.so-active>div>a {
  color: #fff;
}

.header-role .el-menu,
.header-role .el-menu:hover {
  background: #252531;
  color: #fff;
}

.so-normal span,
.so-normal span a,
.so-top span {
  cursor: pointer;
  /* color: rgb(51, 51, 51); */
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
}

div.so-normal,
li.so-normal,
div.el-dropdown {
  list-style-type: none;
  float: left;
  height: 30px;
  line-height: 30px;
  margin-right: 20px;
}

div li.so-normal a {
  cursor: pointer;
  color: rgb(51, 51, 51);
}

.bg-purple-white .el-dropdown {
  padding: 0px 8px;
  margin-right: 16px;
}

.el-dropdown-menu__item a {
  color: #333;
}

.so-top .font-color-yellow {
  color: yellow;
}

.el-dropdown-link-div {
  font-size: 12px;
  color: rgb(51, 51, 51);
}

.el-dropdown-link-div i {
  font-size: 12px;
}

.header-language {
  display: flex;
  align-items: center;
  min-width: 260px;
}
.userAvatar{
  width: 30px;
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue